import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChiller = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 156.69,
	height: 115.5,
	viewBox: "0 0 156.69 115.5",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 149.0 12.5 A 5.0 13.0 0.0 1 1 149.0 52.5 L 19.0 52.5 A 5.0 13.0 0.0 1 1 19.0 12.5 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 149.0 72.5 A 5.0 13.0 0.0 1 1 149.0 112.5 L 19.0 112.5 A 5.0 13.0 0.0 1 1 19.0 72.5 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 4.0 79.5 L 13.0 79.5 M 4.0 105.5 L 13.0 105.5 M 4.0 69.5 L 4.0 89.5 M 0.0 69.5 L 0.0 89.5 M 4.0 95.5 L 4.0 115.5 M 0.0 95.5 L 0.0 115.5 M 139.0 12.5 L 139.0 4.0 M 129.0 4.0 L 149.0 4.0 M 129.0 0.0 L 149.0 0.0 M 29.0 12.5 L 29.0 4.0 M 19.0 4.0 L 39.0 4.0 M 19.0 0.0 L 39.0 0.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 34,
			y: 52.5,
			width: 10,
			height: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 119,
			y: 52.5,
			width: 10,
			height: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgChiller;
